import React from 'react';
import PropTypes from 'prop-types';
import { makeStyles } from '@material-ui/core/styles';
import AppBar from '@material-ui/core/AppBar';
import Tabs from '@material-ui/core/Tabs';
import Tab from './Tab';

const propTypes = {
  location: PropTypes.shape({
    pathname: PropTypes.string.isRequired,
  }).isRequired,
  routes: PropTypes.arrayOf(PropTypes.shape({})),
};

const defaultProps = {
  routes: [],
};

const useStyles = makeStyles(theme => ({
  pageNav: {
    backgroundColor: '#ffffff',
    color: '#3f82bf',
    [theme.breakpoints.down('xs')]: {
      padding: theme.spacing(0, 2),
    },
    [theme.breakpoints.up('sm')]: {
      top: 64,
    },
  },
  tabs: {
    padding: '0 22px',
    [theme.breakpoints.down('xs')]: {
      padding: '0 0',
    },
  },
  indicator: {
    backgroundColor: '#3f82bf',
    borderRadius: '2px 2px 0 0',
    height: 4,
  },
}));

function Navbar({ location, routes }) {
  const classes = useStyles();
  const currentPath = location.pathname
    .split('/')
    .slice(0, 3)
    .join('/');
  const tabs = routes
    .filter(el => el.path.split('/').length === 3)
    .map(el => (
      <Tab key={el.name} disableRipple href={el.path} label={el.name} value={el.path} />
    ));

  return routes.length > 0
    ? (
      <AppBar classes={{ root: classes.pageNav }} component="div" elevation={0} position="sticky">
        <Tabs classes={{ root: classes.tabs, indicator: classes.indicator }} component="nav" value={currentPath}>
          {tabs}
        </Tabs>
      </AppBar>
    )
    : null;
}

Navbar.propTypes = propTypes;
Navbar.defaultProps = defaultProps;

export default Navbar;
